import { useAppSelector } from 'src/store/hooks';
import ProgressBar from './ProgressBar';

const ProgressBarComponent: React.FC = () => {
  const isLoading = useAppSelector(state => state.loader.isProgress);
  return isLoading ? <ProgressBar /> : null;
};

export default ProgressBarComponent;
